import ArticleHeader from '@components/HeadlineLead/ArticleHeader'

import HeadlineWrapper from './HeadlineWrapper'

const exports = {
  ArticleHeader,
  HeadlineWrapper,
}

export default exports
